import {DataTableColumn} from "mantine-datatable";
import {NavLink} from "react-router-dom";
import {Pipeline} from "../types.ts";
import {I18n} from "@aws-amplify/core";
import {formatTimestamp, TIMESTAMP_PLACEHOLDER} from "../../../../utils/TableTimestamps.tsx";
import {PipelineStatusBadge} from "../components/PipelineStatusBadge.tsx";
import config from "../config";


export const usePipelinesTableColumns = () => {

    const columns: DataTableColumn<Pipeline>[] = [
        {
            accessor: 'name',
            title: I18n.get('Name'),
            sortable: true,
            width: '1fr',
            render: (item: Pipeline) => (
                <NavLink to={`${config.basePath}/${encodeURIComponent(item.id)}`}>{item.name}</NavLink>
            ),
        },
        {
            accessor: 'pipelineType',
            title: I18n.get('Pipeline Type'),
            sortable: true,
            width: '1fr',
            render: (item: Pipeline) => item.pipelineType ?? TIMESTAMP_PLACEHOLDER,
        },
        {
            accessor: 'codeRepositoryName',
            title: I18n.get('Repository'),
            sortable: true,
            width: '1fr',
            render: (item: Pipeline) => item.codeRepositoryName ?? TIMESTAMP_PLACEHOLDER,
        },
        {
            accessor: 'pipelineStatus',
            title: I18n.get('Status'),
            sortable: true,
            width: '1fr',
            render: (item: Pipeline) => <PipelineStatusBadge status={item.pipelineStatus}/>,
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            sortable: true,
            width: '1fr',
            render: (item: Pipeline) => formatTimestamp(item.created),
        },
    ];

    return {
        columns,
    };
};
